import { Dispatch, SetStateAction } from 'react';
import { X } from 'lucide-react';
import dynamic from 'next/dist/shared/lib/dynamic';
import Modal from '../v2/common/Modal';
import i18n from '@/settings/i18n';

const t = i18n.init('buyback');

const TradeInWidget = dynamic(() => import('./TradeInWidget'), {
  ssr: false,
});

const Header = ({
  setShowModal,
}: {
  setShowModal: Dispatch<SetStateAction<boolean>>;
}) => (
  <div className="sticky top-0 z-[70] flex items-center justify-between bg-white p-4 text-sm shadow">
    <div>
      <h1 className="w-full text-base font-extrabold leading-5">{t`Trade-in`}</h1>
    </div>
    <button
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-700 text-white  transition duration-150 ease-in-out hover:scale-110 focus:outline-none"
      onClick={() => setShowModal(false)}
    >
      <X className="h-4 w-4" />
    </button>
  </div>
);

const Content = () => (
  <div className="h-full bg-[#F2F2F2] p-4 text-sm">
    <p className="mb-4 text-center">{t`Trade In Your Device`}</p>
    <TradeInWidget />
  </div>
);

/** The trade-in widget with its header, without a modal of its own. */
export const TradeInSliderContent = ({ onClose }: { onClose: () => void }) => (
  <>
    <Header setShowModal={() => onClose()} />
    <Content />
  </>
);

const TradeInSlider = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}) => (
  <Modal
    isOpen={showModal}
    onClose={() => setShowModal(false)}
    width="md:max-w-[800px]"
  >
    <Header setShowModal={setShowModal} />
    <Content />
  </Modal>
);

export default TradeInSlider;
